// 老師端批次上傳的每日剩餘次數（kanban 1000892，比照國中 chaiwriting-j）。
//
// 批次後端對每位老師的批次上傳次數有每日上限（國中、高中共用同一個計數，一次批次
// 上傳算 1 次、追加也算 1 次）。後端一直都在擋，高中前端原本沒有顯示、也沒有在
// 用完時給人話：送單被回 429 時使用者看到的是原始錯誤字串。

/** 與國中相同的文案（chaiwriting-j pages/batch-upload.js） */
export const DAILY_LIMIT_MESSAGE = "今日剩餘次數為0，請明日再使用";

/**
 * 解析 GET /batch-orders/remaining/{creatorID} 的回應。
 * 後端目前回 { remaining_quota: N }；國中前端也相容 remaining / 純數字，這裡照收。
 * 讀不到回 null：顯示「—」、不擋（跟國中一樣，不能因為查不到次數就把功能藏起來）。
 */
export const parseRemainingQuota = (data: unknown): number | null => {
  if (typeof data === "number") return Number.isFinite(data) ? data : null;
  if (!data || typeof data !== "object") return null;
  const d = data as Record<string, unknown>;
  const v = d.remaining_quota ?? d.remaining ?? d.Remaining;
  return typeof v === "number" && Number.isFinite(v) ? v : null;
};

/**
 * 每日次數用盡 = 建單端點（POST /batch-orders）回 429（後端 DailyLimitExceededError）。
 * 只認這個端點：送單前還會打建班、建題、上傳圖片等端點，那些若被閘道回 429 不是額度問題，
 * 不能講成「今日剩餘次數為0」。舊式純 Error 只認後端那句 detail 當備援。
 */
export const isDailyLimitError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  const e = error as { name?: unknown; status?: unknown; path?: unknown; message?: unknown };
  if (e.name === "BatchApiError") return e.status === 429 && e.path === "/batch-orders";
  return typeof e.message === "string" && e.message.includes("Daily batch order limit");
};

/** 剩餘次數的三種狀態：載入中（不顯示）、讀不到（顯示「—」、不擋）、有數字 */
export type BatchQuota =
  | { state: "loading" }
  | { state: "unknown" }
  | { state: "ok"; remaining: number };

export const quotaFromResponse = (data: unknown): BatchQuota => {
  const n = parseRemainingQuota(data);
  return n === null ? { state: "unknown" } : { state: "ok", remaining: n };
};

/** 顯示用字串；載入中回 null（不顯示徽章） */
export const quotaLabel = (quota: BatchQuota): string | null =>
  quota.state === "loading" ? null : quota.state === "unknown" ? "—" : String(quota.remaining);

/** 只有「確定讀到且 <= 0」才擋；讀不到交給後端把關（同國中） */
export const quotaExhausted = (quota: BatchQuota): boolean =>
  quota.state === "ok" && quota.remaining <= 0;
